import { render } from "./CoursesRepartition.vue?vue&type=template&id=700bff3a&scoped=true"
import script from "./CoursesRepartition.vue?vue&type=script&lang=js"
export * from "./CoursesRepartition.vue?vue&type=script&lang=js"

import "./CoursesRepartition.vue?vue&type=style&index=0&id=700bff3a&scoped=true&lang=css"

import exportComponent from "D:\\Dev\\Projects\\Web\\era-old.proj\\era.alpha-23-24.local\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.3.8_vue@3.3.8_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-700bff3a"]])

export default __exports__